import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import OnboardingCheck from "./components/OnboardingCheck";
import Dashboard from "./Dashboard";
import EntryTable from "./components/EntryTable";
import Input from "./input";
import Customize from "./Customize";
import Onboarding from "./components/Onboarding";
import Login from "./Login";
import Register from "./Register";
import Privacy from "./Privacy";
import ChangePassword from "./ChangePassword";
import "./App.css";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/datenschutz" element={<Privacy />} />
            <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
            <Route path="/" element={<ProtectedRoute><OnboardingCheck><Dashboard /></OnboardingCheck></ProtectedRoute>} />
            <Route path="/input" element={<ProtectedRoute><OnboardingCheck><Input /></OnboardingCheck></ProtectedRoute>} />
            <Route path="/entrytable" element={<ProtectedRoute><OnboardingCheck><EntryTable /></OnboardingCheck></ProtectedRoute>} />
            <Route path="/customize" element={<ProtectedRoute><Customize /></ProtectedRoute>} />
            <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;